"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var PIXI = _interopRequireWildcard(require("pixi.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Smoke = exports["default"] = /*#__PURE__*/function (_PIXI$Container) {
  // The smoke is blended into the background, it's only functionality is to rotate and use sine math to alpha in and out
  function Smoke(background) {
    var _this;
    _classCallCheck(this, Smoke);
    _this = _callSuper(this, Smoke);
    _defineProperty(_this, "background", void 0);
    _defineProperty(_this, "data", void 0);
    _defineProperty(_this, "smokeFx", void 0);
    _defineProperty(_this, "originPos", void 0);
    _defineProperty(_this, "alphaLimit", void 0);
    _defineProperty(_this, "speed", void 0);
    _defineProperty(_this, "speedScale", void 0);
    _defineProperty(_this, "disipate", void 0);
    _defineProperty(_this, "disipateSpeed", void 0);
    _defineProperty(_this, "speedRot", void 0);
    _defineProperty(_this, "sin", void 0);
    _defineProperty(_this, "sinScale", void 0);
    _defineProperty(_this, "scaleLimit", void 0);
    _this.background = background;
    return _this;
  }
  _inherits(Smoke, _PIXI$Container);
  return _createClass(Smoke, [{
    key: "build",
    value: function build(data) {
      this.data = data;
      this.smokeFx = PIXI.Sprite.from("smoke_" + this.data.type + "_" + this.data.num + ".jpg");
      this.addChild(this.smokeFx);
      this.smokeFx.scale.x = this.data.width / this.smokeFx.width;
      this.smokeFx.scale.y = this.data.height / this.smokeFx.height;
      this.smokeFx.blendMode = PIXI.BLEND_MODES.ADD;
      this.smokeFx.alpha = 0;
      this.smokeFx.anchor.set(0.5);
      this.smokeFx.scale.set(2.5);
      this.originPos = {
        x: this.x,
        y: this.y
      };
      this.reset();
      this.alphaLimit = 0.5;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.speed = Math.random() * 0.005 + 0.05;
      this.speedScale = Math.random() * 0.005 + 0.005;
      this.disipate = true;
      this.disipateSpeed = Math.random() * 0.005;
      this.speedRot = Math.random() * 0.04 - 0.02;
      this.speedRot *= 0.05;
      this.speedScale *= 0.15;
      this.sin = Math.random() * 5;
      this.sinScale = Math.random() * 5;
      this.alphaLimit = 0.25;
      this.scaleLimit = 7;
    }
  }, {
    key: "warpping",
    value: function warpping() {
      this.speedRot *= 10;
      this.speed *= 2;
      this.alphaLimit = 0.75;
      this.scaleLimit = 10;
    }
  }, {
    key: "update",
    value: function update() {
      this.sin += this.speed;
      this.sinScale += this.speedScale;
      var n = Math.sin(this.sin) * 0.5 + 0.5;
      var n2 = Math.sin(this.sinScale) * 0.5 + 0.5;
      this.sin %= Math.PI * 2;
      this.x = n;
      this.smokeFx.rotation += this.speedRot;
      this.smokeFx.alpha = n * this.alphaLimit + this.alphaLimit * 0.5;
      this.smokeFx.scale.set(n2 * (this.scaleLimit * 0.5) + this.scaleLimit * 0.5);
    }
  }, {
    key: "show",
    value: function show(delay) {
      if (this.data.type == "top") {
        this.smokeFx.tint = this.background.colorSet.topSmokeStandard;
      } else {
        this.smokeFx.tint = this.background.colorSet.bottomSmokeStandard;
      }
    }
  }, {
    key: "hide",
    value: function hide(delay) {
      if (this.data.type == "top") {
        this.smokeFx.tint = this.background.colorSet.topSmokeWarp;
      } else {
        this.smokeFx.tint = this.background.colorSet.bottomSmokeWarp;
      }
    }
  }]);
}(PIXI.Container);
//# sourceMappingURL=Smoke.js.map